export default "__VITE_ASSET__18405288__"